var React = require('react');
var PropTypes = React.PropTypes;
import MCQuestionContent from './MCQuestion';
import ShortQuestionContent from './ShortQuestion';
import LongQuestionContent from './LongQuestion';

var QuestionContent = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      questions: nextProps.questions
    })
  },
  getInitialState: function() {
    return {
      questions: this.props.questions
    };
  },
  render: function() {
    var _this = this;
    return (
      <div>
        {
          _this.state.questions.map(function(question, index) {
            return (
              (question.kquestion.type === 11 &&
                <MCQuestionContent
                  conceptLeafMapping={_this.props.conceptLeafMapping}
                  kquestion={question.kquestion}
                  questionIndex={_this.props.questionIndex || index}
                  key={index}
                />)
              ||
              (question.kquestion.type === 21 &&
                <ShortQuestionContent
                  conceptLeafMapping={_this.props.conceptLeafMapping}
                  kquestion={question.kquestion}
                  questionIndex={_this.props.questionIndex || index}
                  key={index}
                />)
              ||
              (question.kquestion.type === 22 &&
                <LongQuestionContent
                  conceptLeafMapping={_this.props.conceptLeafMapping}
                  kquestion={question.kquestion}
                  questionIndex={_this.props.questionIndex || index}
                  parentContent={_this.props.children}
                  key={index}
                  subject={_this.props.subject}
                />)
            )
          })
        }
      </div>
    );
  }

});

module.exports = QuestionContent;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/QuestionContent.js
 **/